export const FormatConstant = {
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
